import { LegalShell } from './LegalShell';

// PLACEHOLDER copy — Legal team must replace before production.
// The effective date here MUST match TERMS_VERSION in shared/legalVersion.ts;
// the first-login acceptance gate compares users' terms_accepted_version.

export function TermsPage() {
  return (
    <LegalShell title="Terms &amp; Conditions" effectiveDate="2026-08-03">
      <div className="bg-warning-soft border border-warning/40 rounded p-3 text-[11px] text-warning-strong">
        <strong>PLACEHOLDER:</strong> Legal team replaces this document before production release.
      </div>

      <section>
        <h2 className="font-bold text-navy">1. Acceptance of terms</h2>
        <p>
          By accessing or using DreamTrials, you agree to be bound by these
          Terms &amp; Conditions. If you do not agree, you must not use the
          platform. First-time users are required to accept these terms
          explicitly before entering the application.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">2. Authorised use</h2>
        <p>
          DreamTrials is a professional clinical trial management platform.
          Access is granted to Site staff, Sponsor staff, Monitors, Auditors,
          and Regulatory personnel based on their assigned role and delegation
          of authority. You must only access data for which you have been
          granted a legitimate operational reason.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">3. Account security</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Multi-factor authentication is mandatory. Do not share TOTP codes or recovery codes.</li>
          <li>Passwords must meet the platform&rsquo;s complexity policy and are rotated at reset time.</li>
          <li>You must sign out at the end of a session on shared devices; idle sessions time out after 15 minutes.</li>
          <li>Report suspected credential compromise immediately to your Site Administrator.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-bold text-navy">4. Electronic signatures (21 CFR Part 11)</h2>
        <p>
          All e-signatures captured in DreamTrials — including visit sign-off,
          DoA row signatures, PI countersignatures, e-consent, and eISF version
          approvals — are legally binding and equivalent to a handwritten
          signature. Signing requires re-authentication and captures a
          contemporaneous audit event including signer identity, timestamp,
          signature meaning, and IP.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">5. PHI &amp; confidentiality</h2>
        <p>
          Protected Health Information is masked by default. Revealing PHI
          requires an explicit grant scoped to specific fields, granted by
          authorised personnel, with an expiry. Every reveal is audited.
          Unauthorised disclosure or attempts to bypass PHI controls are
          prohibited.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">6. Prohibited actions</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Using another user&rsquo;s credentials.</li>
          <li>Bypassing or tampering with the audit trail.</li>
          <li>Exporting PHI outside authorised channels.</li>
          <li>Attempting to access data belonging to a tenant, site, or study you are not delegated to.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-bold text-navy">7. Suspension &amp; termination</h2>
        <p>
          Violations of these terms may result in immediate account suspension,
          disciplinary action by the sponsor, and reporting to regulatory
          authorities.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">8. Changes to these terms</h2>
        <p>
          We may revise these terms. Material changes require re-acceptance at
          the next login before you can continue using the platform.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">9. Contact</h2>
        <p>
          Questions: <a href="mailto:support@zertain.com" className="text-blue">support@zertain.com</a>.
          Regulatory / Compliance: <a href="mailto:compliance@zertain.com" className="text-blue">compliance@zertain.com</a>.
        </p>
      </section>
    </LegalShell>
  );
}
